"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InnerDrawerWrapper = _styledComponents.default.div.attrs({
  "data-qa": "inner-drawer-wrapper"
}).withConfig({
  displayName: "InnerDrawer__InnerDrawerWrapper",
  componentId: "sc-1qjvgx-0"
})(["background-color:", ";min-height:", ";width:100vw;overflow-y:scroll;-webkit-overflow-scrolling:touch;"], function (props) {
  return props.theme.carvana.gray.background;
}, function (props) {
  return props.screenHeight ? "".concat(props.screenHeight, "px;") : '100vh;';
});

var InnerDrawer = function InnerDrawer(_ref) {
  var children = _ref.children,
      className = _ref.className,
      screenHeight = _ref.screenHeight;
  return _react.default.createElement(InnerDrawerWrapper, {
    className: className,
    screenHeight: screenHeight,
    "data-qa": "inner-drawer"
  }, children);
};

InnerDrawer.defaultProps = {
  className: '',
  screenHeight: null
};
var _default = InnerDrawer;
exports.default = _default;
module.exports = exports.default;